import { Stack, Chip } from '@mui/material';
import { InvalidReasons } from '@sr/dto';


type ReasonRule = {
  label: string;
  priority: number;
};

const reasonRules: Record<keyof InvalidReasons, ReasonRule> = {
  hasDuplicate: {
    label: '⧉ дубликат',
    priority: 40
  },
  importEntryAlreadyExists: {
    label: '⧉ повторный',
    priority: 40
  },
  payerLegalEntityNotFound: {
    label: '✖ плательщик',
    priority: 30
  },
  receiverLegalEntityNotFound: {
    label: '✖ получатель',
    priority: 30
  },
  invoiceNotFound: {
    label: '⌀ нет счетов',
    priority: 20
  },
  paymentAmountExceedsInvoice: {
    label: '⌀ сумма больше',
    priority: 10
  }
};

// выводим элементы с одинаковым наивысшим priority, облегчаем интерфейс
const resolveVisibleReasons = (reasons: InvalidReasons): ReasonRule[] => {
  let maxPriority = -Infinity;
  const matched: ReasonRule[] = [];
  
  const keys = Object.keys(reasons) as (keyof InvalidReasons)[];
  
  for (const key of keys) {
    if (!reasons[key]) continue;

    const rule = reasonRules[key];
    if (!rule) continue;

    if (rule.priority > maxPriority) {
      maxPriority = rule.priority;
      matched.length = 0;
      matched.push(rule);
    } else if (rule.priority === maxPriority) {
      matched.push(rule);
    }
  }

  return matched;
};


const InvalidChip = ({ label }: { label: string }) => {
  return (
    <Chip size='small' variant='outlined' label={label}
      sx={ { fontWeight: 500, borderColor: 'text.primary', color: 'text.primary' } }/>
  );
};


export const RowStatusInfoCell = ({ reasons }: { reasons?: InvalidReasons }) => {
  if (!reasons) return <></>;

  const visibleReasons = resolveVisibleReasons(reasons);
  if (!visibleReasons.length) return <></>;

  return (
    <Stack direction="column" gap={1}>
      {visibleReasons.map(r => (
        <InvalidChip key={r.label} label={r.label} />
      ))}
    </Stack>
  );
};
